/* eslint-disable react/prop-types */
import ModalUI from "components/ModalUI";
import React, { useEffect, useState } from 'react'
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import queryString from "utils/queryString";
import InvestmentTransactionsTable from "./InvestmentTransactionsTable";
import Loading from "components/Loading";
import SoftButton from "components/SoftButton";
import { getInvestmentOpportunityTransactions } from "services/investmentOpportunity.routes";
import { getInvestmentTransactionsExport } from "services/investmentOpportunity.routes";

export default function InvestmentTransactionsModal({ modalInfo, closeModal }) {
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [investmentTransactions, setInvestmentTransactions] = useState([])

    useEffect(() => {
        if (modalInfo?.investmentId) {
            setLoading(true);
            let query = {
                cursor: cursor === null ? null : cursor,
                per_page: 25,
                investment_opportunity_id: modalInfo?.investmentId,
                with_ghollak: 1
            }

            getInvestmentOpportunityTransactions(queryString(query), (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message)
                } else {
                    if (page !== 0) {
                        setInvestmentTransactions((prev) => ([...prev, ...data.data]));
                    } else {
                        setInvestmentTransactions(data.data);
                    }
                    setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                    setHasMore(data.meta.next_cursor !== null);
                }
            })
        }
    }, [page]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }

    const exportToExcel = () => {
        let query = {
            investment_opportunity_id: modalInfo?.investmentId
        };

        setLoading(true);
        getInvestmentTransactionsExport(queryString(query), (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                window.open(data.link, '_blank');
            }
        })
    }
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px", minHeight: "500px" }}>
            <Loading loading={loading} />
            <SoftButton variant="gradient" onClick={exportToExcel} color="success" size="small">
                دانلود خروجی اکسل
            </SoftButton>
            <InfiniteScroll dataLength={investmentTransactions.length} next={fetchMoreData} height={450} hasMore={hasMore}>
                <InvestmentTransactionsTable data={investmentTransactions} />
            </InfiniteScroll>
        </ModalUI>
    )
}
